import { navLinks, categoryChips } from "@/mocks/site";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full border-t border-accent-200 bg-accent-50 px-4 py-14 md:px-8">
      <div className="grid gap-10 lg:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-tv-2-line text-lg" />
            </span>
            <span className="text-lg tracking-wide text-foreground-950">51动漫</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
            51动漫新番以当季作品为核心，整合新番推荐、热门动漫排行、番剧表与动漫资讯，
            帮助追番用户快速了解开播时间与剧情看点，并按喜好筛选目标作品。
          </p>
          <div className="mt-5 flex flex-wrap gap-1.5">
            {categoryChips.slice(0, 6).map((chip) => (
              <span
                key={chip}
                className="rounded-full bg-background-50 px-3 py-1 text-[11px] text-foreground-600 ring-1 ring-background-200"
              >
                {chip}
              </span>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-wide text-foreground-950">页内导航</h4>
          <ul className="mt-4 space-y-2.5">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-wide text-foreground-950">内容说明</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
            <li className="flex gap-2">
              <i className="ri-book-open-line mt-0.5 text-primary-500" />
              排行与口碑为综合整理结果，供追番参考
            </li>
            <li className="flex gap-2">
              <i className="ri-calendar-2-line mt-0.5 text-primary-500" />
              番剧表按每周放送习惯编排
            </li>
            <li className="flex gap-2">
              <i className="ri-cursor-line mt-0.5 text-primary-500" />
              标签筛选仅作用于本页内容
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-accent-200 pt-6 sm:flex-row sm:items-center">
        <p className="text-xs text-foreground-500">
          © {year} 51动漫 · 51动漫新番内容整理与展示
        </p>
        <a
          href="#top"
          className="inline-flex items-center gap-1.5 text-xs text-foreground-600 transition-colors hover:text-primary-700"
        >
          <i className="ri-arrow-up-line" />
          回到顶部
        </a>
      </div>
    </footer>
  );
}